export class LearndashCourseOrder {
  type: 'topic' | 'lessons';
  id: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-denylist, id-match
  post_title: string;
  parent?: string;
  attachedPDFs?: string[];
}
